import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Pages
import Home from './pages/Home';
import Search from './pages/Search';
import AuthScreen from './pages/AuthScreen';
import Privacy from './pages/Privacy';
import MyProfile from './pages/MyProfile';
import EditProfile from './pages/EditProfile';
import Profile from './pages/Profile';
import AdDetail from './pages/AdDetail';
import CreateAd from './pages/CreateAd';
import EditAd from './pages/EditAd';
import MyRequests from './pages/MyRequests';
import Conversation from './pages/Conversation';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public pages */}
        <Route path="/" element={<Home />} />
        <Route path="/zoeken" element={<Search />} />
        <Route path="/inloggen" element={<AuthScreen />} />
        <Route path="/privacy" element={<Privacy />} />
        
        {/* Ad pages */}
        <Route path="/oproep/:adId" element={<AdDetail />} />
        <Route path="/oproep/nieuw" element={<CreateAd />} />
        <Route path="/oproep/:adId/bewerken" element={<EditAd />} />
        
        {/* Profile pages */}
        <Route path="/profiel" element={<MyProfile />} />
        <Route path="/profiel/bewerken" element={<EditProfile />} />
        <Route path="/muzikant/:userId" element={<Profile />} />
        
        {/* Messaging */}
        <Route path="/berichten" element={<MyRequests />} />
        <Route path="/berichten/:conversationId" element={<Conversation />} />
        
        {/* 404 catch-all - must be last */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
